import React from "react";
import { useLang } from "@/context/LanguageContext";
import { Reveal } from "@/components/site/Reveal";

export default function Testimonials() {
  const { t } = useLang();
  const data = t.testimonialsData;

  return (
    <section data-testid="testimonials-section" className="bg-surface py-16 md:py-24 border-y border-sandborder">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal className="mb-16">
          <p className="label-mono text-ocean mb-6">{t.testimonials.label}</p>
          <h2 className="font-outfit font-semibold text-4xl md:text-6xl tracking-tight text-ink">
            {t.testimonials.title}
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-16">
          {data.map((r, i) => (
            <Reveal key={i} delay={(i % 2) * 0.1}>
              <figure data-testid={`testimonial-${i}`} className="border-t border-black/10 pt-8">
                <blockquote className="font-playfair text-2xl md:text-3xl leading-snug text-ink">
                  “{r.quote}”
                </blockquote>
                <figcaption className="mt-6 flex items-center gap-3">
                  <span className="font-outfit font-semibold text-ink">{r.name}</span>
                  <span className="w-8 h-px bg-sand" />
                  <span className="label-mono text-ink/50">{r.from}</span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
